import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MaterialModule } from '../material.module';
import { TranslateModule } from '@ngx-translate/core';
import { PreautorisationNotificationComponent } from './components/preautorisation-notification/preautorisation-notification.component';
import { NotificationsComponent } from './notifications.component';
import { PlaceBubbleComponent } from './components/place-bubble-notification/place-bubble-notification.component';
import { PreautorisationNotificationDsdComponent } from './components/preautorisation-notification-dsd/preautorisation-notification-dsd.component';
import { CheminAbsoluStatiquePipe } from '../shared/pipes/chemin-absolu-statique.pipe';

export const COMPONENTS = [
  PreautorisationNotificationComponent,
  PreautorisationNotificationDsdComponent,
  NotificationsComponent,
  PlaceBubbleComponent
];

@NgModule({
  declarations: COMPONENTS,
  exports: [NotificationsComponent, COMPONENTS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, MaterialModule, TranslateModule],
  providers: [CheminAbsoluStatiquePipe, provideHttpClient(withInterceptorsFromDi())]
})
export class NotificationModule {
  static forRoot(): ModuleWithProviders<NotificationModule> {
    return {
      ngModule: NotificationModule
    };
  }
}
